export default "__VITE_ASSET__CWxLYMtG__"